
import { defineComponent, reactive, watchEffect } from 'vue';
import JoinRacesTable from './race-tables/JoinRacesTable.vue';
import LiveRacesTable from './race-tables/LiveRacesTable.vue';
import MyRaces from './race-tables/MyRaces.vue';
import MyQueues from './race-tables/MyQueues.vue';
import { Redo as SearchIcon, Info as InfoIcon } from '@vicons/fa';
import { maxTicketPrice, minTicketPrice, refresh } from './race-tables/race-filters';
import { EthersService as eth } from '../services';
import breakpoints from '../utils/breakpoints';

export default defineComponent({
  name: 'Upcoming',
  components: { JoinRacesTable, LiveRacesTable, MyRaces, MyQueues, SearchIcon, InfoIcon },
  setup () {
    const filtersModel = reactive({
      minTicketPrice: minTicketPrice.value,
      maxTicketPrice: maxTicketPrice.value
    });

    const search = () => {
      minTicketPrice.value = filtersModel.minTicketPrice;
      maxTicketPrice.value = filtersModel.maxTicketPrice;
      refresh.value = true;
    };

    watchEffect(() => {
      filtersModel.minTicketPrice = minTicketPrice.value;
      filtersModel.maxTicketPrice = maxTicketPrice.value;
    });
    
    return {
      filtersModel,
      search,
      ethReactive: eth.reactive,
      breakpoints: breakpoints
    };
  }
});
